import Button from '@material-ui/core/Button';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled, { keyframes, css } from 'styled-components';

/**
 * Estilização do componente OpacityPulse
 */
export const opacityPulse = keyframes`
 0% {
    opacity: 1;
  }
  66% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

/**
 * Estilização da div
 */
export default styled.div`
  display: flex;
  flex-wrap: nowrap;

  .content {
    margin: 0 9px 0 30px;
  }

  aside {
    color: #5e5e5e;
    position: relative;
    height: 100%;
    padding-top: 48px;
    padding-bottom: 64px;
    flex: 0 0 388px;

    @media (max-width: 768px) {
      flex: 0 0 100vw;
    }

    header {
      position: absolute;
      top: 0px;
      height: 48px;
      width: 100%;
      text-align: center;
      padding: 0 30px;

      .MuiTextField-root {
        width: 100%;

        input {
          font-size: 12px;
          line-height: 14px;
        }

        .MuiInput-underline:before {
          border-bottom: 1px solid #e5e5e5;
        }

        label {
          font-size: 12px;
          line-height: 14px;
          top: -10px;
          left: 5px;

          &.Mui-focused {
            top: 0;
          }
        }
      }

      button {
        position: absolute;
        top: 10px;
        right: 30px;
        background: none;
        cursor: pointer;
        border: none;
      }
    }

    > div.list {
      height: 100%;
      overflow: scroll;

      @media (min-width: 768px) {
        max-width: 360px;
      }

      /* width */
      ::-webkit-scrollbar {
        width: 21px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
        background: transparent;
      }

      /* Handle */
      ::-webkit-scrollbar-thumb {
        background: #d8d8d8;
        border-radius: 10px;
        border: 8px solid #fff;

        /* Handle on hover */
        &:hover {
          background: #5d5d5d;
        }
      }
    }

    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;

      .content {
        padding: 10px 0;
        border-top: 1px solid #e5e5e5;
      }
    }
  }

  > .details {
    position: relative;
    flex: 0 0 400px;
    border-left: 1px solid #e5e5e5;
    background: white;

    .metadata {
      max-height: 230px;
      overflow: auto;
      padding: 10px 30px 0 30px;
    }

    @media (max-width: 768px) {
      position: fixed;
      top: 56px;
      z-index: 5;
      height: calc(100vh - 56px);
      width: 100%;
      display: ${({ showingDetails }) => (showingDetails ? 'block' : 'none')};
      .metadata {
        max-height: calc(100vh - 276px);
        overflow: auto;
        padding: 10px 30px 10px 30px;
      }
    }

    h1 {
      font-size: 18px;
      line-height: 16px;
      margin: 25px 0 21px 0;
    }

    footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 60px;

      @media (max-width: 768px) {
        display: none;
      }

      .content {
        text-align: right;
        padding: 10px 0;
        border-top: 1px solid #e5e5e5;
      }
    }
  }

  .fixed_header {
    position: fixed;
    top: 0;
    width: 100%;
    background: white;
  }
`;

// TODO Criar estilos de Botão padrão para todo o sistema utilizando styledcomponents, conversar com equipe de design para padronizar padding, etc
/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  width: 100%;

  &.MuiButton-root {
    text-transform: none;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 16px;
  }

  &.MuiButton-contained {
    color: #fff;
    background: #3c71dd;

    &:hover {
      background: #3463c1;
    }
  }

  &:disabled {
    background: #aeaeae;
  }
`;

/**
 * Estilização do componente TransparentButton
 */
export const TransparentButton = styled(Button)`
  &.MuiButton-root {
    text-transform: none;
    padding: 6px 20px;
    font-size: 14px;
    line-height: 16px;
    color: #3c71dd;

    svg {
      margin-right: 5px;
      vertical-align: middle;
      path {
        fill: #3c71dd;
      }
    }
  }

  &:disabled {
    background: #e0e0e0;
  }
`;

/**
 * Estilização do componente Preview
 */
export const Preview = styled.div`
  &.preview {
    background: #5b5b5b;
    width: 100%;
    height: 220px;
    text-align: center;
    position: relative;

    svg {
      path {
        /* fill: ${({ theme }) => theme.primaryColor}; */
        fill: #ccc;

        ${({ loading }) =>
          loading &&
          css`
            animation: ${opacityPulse} 2s ease-in-out infinite;
          `}
      }
    }

    p {
      position: absolute;
      top: 45%;
      width: 100%;
      transform: translateY(-50%);
      text-align: center;
      color: #ccc;
    }
  }
`;
